module.exports = require('./helpers/bundle-url').getBundleURL('LyihG') + "logo-dark.eefe0b7f.svg";